module.exports = __webpack_public_path__ + "img/icon-billet-recurrency.84540745.svg";